import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function FornecedorList() {
  const [fornecedores, setFornecedores] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => { fetchFornecedores(); }, []);

  const fetchFornecedores = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const res = await api.get('/fornecedores/', { headers: { Authorization: `Bearer ${token}` } });
      setFornecedores(res.data);
    } catch {
      toast.error('Erro ao carregar os fornecedores.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este fornecedor?')) return;
    try {
      const token = localStorage.getItem('access_token');
      await api.delete(`/fornecedores/${id}/`, { headers: { Authorization: `Bearer ${token}` } });
      setFornecedores(fornecedores.filter((f) => f.id !== id));
      toast.success('Fornecedor excluído.');
    } catch {
      toast.error('Erro ao excluir o fornecedor.');
    }
  };

  const filtered = fornecedores.filter((f) =>
    f.razao_social.toLowerCase().includes(search.toLowerCase()) ||
    (f.nome_fantasia || '').toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Fornecedores</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">Lista de Fornecedores</span>
            <span className="produto-tab" onClick={() => navigate('/fornecedores/novo')}>
              Novo Fornecedor
            </span>
          </div>
        </div>
        <div className="produto-header-actions">
          <div className="produto-search-wrap">
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder="Buscar fornecedor..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button className="prd-btn-primary" onClick={() => navigate('/fornecedores/novo')}>
            <span className="material-symbols-outlined">add_business</span>
            Novo Fornecedor
          </button>
        </div>
      </div>

      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">
            {filtered.length} fornecedor{filtered.length !== 1 ? 'es' : ''}
          </span>
          <button className="prd-icon-btn" onClick={fetchFornecedores} title="Atualizar">
            <span className="material-symbols-outlined">refresh</span>
          </button>
        </div>
        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th>Razão Social</th>
                <th>Nome Fantasia</th>
                <th>CNPJ</th>
                <th>Email</th>
                <th>Telefone</th>
                <th className="right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 6 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} className="prd-empty">
                    {search ? 'Nenhum fornecedor encontrado.' : 'Nenhum fornecedor cadastrado.'}
                  </td>
                </tr>
              ) : (
                paginated.map((f) => (
                  <tr key={f.id}>
                    <td>
                      <div className="td-name-wrap">
                        <div className="td-thumb" style={{ background: '#1B263B', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '16px', color: '#cca730' }}>factory</span>
                        </div>
                        <span className="td-name">{f.razao_social}</span>
                      </div>
                    </td>
                    <td>{f.nome_fantasia || '—'}</td>
                    <td>{f.cnpj || '—'}</td>
                    <td>{f.email}</td>
                    <td>{f.telefone || '—'}</td>
                    <td className="right">
                      <div className="td-actions">
                        <button
                          className="prd-icon-btn"
                          onClick={() => navigate(`/fornecedores/editar/${f.id}`)}
                          title="Editar"
                        >
                          <span className="material-symbols-outlined">edit</span>
                        </button>
                        <button
                          className="prd-icon-btn prd-icon-btn--danger"
                          onClick={() => handleDelete(f.id)}
                          title="Excluir"
                        >
                          <span className="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} totalPages={totalPages} onPageChange={(p) => { setPage(p); window.scrollTo(0,0); }} />
      </div>
    </div>
  );
}

export default FornecedorList;
